import axios from '../../../../api/axios';
import React, {useState,useEffect} from 'react'
import {EyeFill,PencilFill,Trash3Fill,PersonPlus,CheckLg} from "react-bootstrap-icons"
import { useNavigate,useParams,Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import loadingIcon from '../../../../Images/loading.gif'
import { isEmpty } from '../../../../Utilities/Utils';
import { useAuth } from '../../../../ContextApp/AuthContext';

function Classe() {

    const {user}=useAuth()
    const i=0
    const [classes_initiales,setClasses_initiales]=useState([])
    const [curentpage,setCurentpage]=useState(1)
    const [search,setSearch]=useState('')
    const [recordperpage,setRecordperpage]=useState(50)
    const navigate=useNavigate()
    
    const lastIndex=curentpage * recordperpage
    const firstIndex=lastIndex - recordperpage
    const {id}=useParams()
    const records= search.toLowerCase() === '' ? classes_initiales.slice(firstIndex, lastIndex) : classes_initiales.filter((classe_initiale)=>{return search.toLowerCase() === '' ? classe_initiale : classe_initiale.nom.toLowerCase().includes(search)}).slice(firstIndex, lastIndex)
    const recordNpage=search.toLowerCase() === '' ? classes_initiales : classes_initiales.filter((classe_initiale)=>{ return classe_initiale.nom.toLowerCase().includes(search)})
    const npage=Math.ceil(recordNpage.length/recordperpage)
    const numbers=[...Array(npage+1).keys()].slice(1)    
    const csrf=()=>axios.get('sanctum/csrf-cookie')
    

   //const recordperpage=2
    
    //const numbers=[1,2,3,4,5]
    const [loading,setLoading]=useState(false)
    

    useEffect(
        ()=>{
            localStorage.setItem("lastpage","/classe_initiale")
                Classes_initialesRequest()
                
        },[])
    const Activation=async(idclasse)=>{
        await axios.post(
            `api/classe/${idclasse}`
        ).then((res)=>{
            Swal.fire({
                title: "Message de confirmation",
                text:res.data.message,
                icon:"information"
            })
            Classes_initialesRequest()
        }).catch((err)=>{
            Swal.fire({
                title: "Erreur",
                text:err.message,
                icon:"error"
            })
        })
    }
    const AlertActivation=(idclasse)=>{
        Swal.fire({
            title:'Message de confirmation',
            text:'Etes-vous sûr de vouloir activer cette classe ?',
            icon:'question',
            showDenyButton:true,
           
            confirmButtonText:'Confirmer',
            denyButtonText:'Annuler'
        }).then((resultat)=>{
            if(resultat.isConfirmed){
              Activation(idclasse)
                    }
        })
    }
    const Classes_initialesRequest=async()=>{
        
        await axios.post('api/getclasses',{idecole:user?.ecole?.id,annee_scolaire:user?.programme_scolaire?.annee_scolaire}).then(
            (res)=>{
                setClasses_initiales(res.data.items)
                setLoading(false)
            }
        ).catch((err)=>{
//
        })
    }
    const Iteration = () => {
    if (loading) return <tr><td colSpan="5" className="text-center py-5"><div className="spinner-border text-primary"></div></td></tr>;

    return records
        .filter(c => search === '' ? c.etat === "Activée" : c.nom.toLowerCase().includes(search))
        .map((classe, index) => (
            <tr key={index}>
                <td className="ps-4 fw-light text-muted">{index + 1}</td>
                <td><span className="fw-bold text-uppercase" style={{fontSize: '0.9rem'}}>{classe.nom}</span></td>
                <td><span className="badge bg-light text-dark border">{classe.niveau}</span></td>
                <td>
                    {isEmpty(classe.idenseignant) ? (
                        <Link className="btn btn-sm btn-outline-primary rounded-pill px-3" to="/titulariat/insertion">
                            <i className="bi bi-person-plus-fill me-1"></i> Titulaire
                        </Link>
                    ) : (
                        <div className="d-flex align-items-center text-primary">
                            <i className="bi bi-person-check-fill me-2"></i> {classe.nomenseignant}
                        </div>
                    )}
                </td>
                <td className="text-end pe-4">
                    <div className="btn-group shadow-sm rounded">
                        <button className="btn btn-white btn-sm" onClick={() => navigate(`${classe.id}`)} title="Modifier">
                            <PencilFill color="royalblue" size={16} />
                        </button>
                        <button className="btn btn-white btn-sm text-danger" onClick={() => AlertNotification(classe.id)} title="Désactiver">
                            <Trash3Fill size={16} />
                        </button>
                    </div>
                </td>
            </tr>
        ));
};

const Desactive = () => {
    return records
        .filter(c => search === '' ? c.etat === "Désactivée" : c.nom.toLowerCase().includes(search))
        .map((classe, index) => (
            <tr key={index} className="table-light">
                <td className="ps-4 w-25 text-decoration-line-through">{classe.nom}</td>
                <td className="text-muted italic small">Section désactivée</td>
                <td className="text-end pe-4">
                    <button className="btn btn-sm btn-success rounded-pill px-3 shadow-sm" onClick={() => AlertActivation(classe.id)}>
                        <CheckLg className="me-1" /> Réactiver
                    </button>
                </td>
            </tr>
        ));
};

 /*   const Desactive=()=>{
        return loading ? (
            <div className='w-100 mx-auto'>
                <img src={loadingIcon} alt='loading'/>
            </div>
        ) : (
            
                records.filter((classe_initiale)=>{
                    return search.toLowerCase() === ''  ? classe_initiale.etat=="Désactivée" : classe_initiale.nom.toLowerCase().includes(search)
                }).map((classe_initiale,indexV)=>
                {
                  return(
                        <tr key={indexV} className='justify-content-start'>
                            <td className='sticky-col'>{indexV+1}</td>
                            <td className='sticky-col'>{classe_initiale.nom.toLowerCase()}</td>
                            
                            <td>{classe_initiale.niveau}</td>
                            <td>{isEmpty(classe_initiale.idenseignant) ? <Link className="btn btn-primary" to="/titulariat/insertion">Ajouter titulaire</Link> :classe_initiale.nomenseignant}</td>
                            <td><CheckLg size={20} color='blue' onClick={()=>AlertActivation(classe_initiale.id)}/></td>
                        </tr>
                  )
                    
                }
                )
            
        )
        
            }   
    const Iteration=()=>{
        return loading ? (
            <div className='w-100 mx-auto'>
                <img src={loadingIcon} alt='loading'/>
            </div>
        ) : (
            
                records.filter((classe_initiale)=>{
                    return search.toLowerCase() === ''  ? classe_initiale.etat=="Activée" : classe_initiale.nom.toLowerCase().includes(search)
                }).map((classe_initiale,indexV)=>
                {
                  return(
                        <tr key={indexV} className='ligne'>
                            <td className='sticky-col'>{indexV+1}</td>
                            <td className='sticky-col'>{classe_initiale.nom.toLowerCase()}</td>
                            
                            <td>{classe_initiale.niveau}</td>
                            <td>{isEmpty(classe_initiale.idenseignant) ? <Link className="btn btn-primary" to="/titulariat/insertion">Ajouter titulaire</Link> :classe_initiale.nomenseignant}</td>
                            <td><Trash3Fill color='brown' size={20} className='d-inline-flex mx-2 icone' onClick={()=>AlertNotification(classe_initiale.id)} /> {!isEmpty(classe_initiale.idenseignant) &&<PencilFill color="royalblue" size={20} className='d-inline-flex mx-2 icone' onClick={()=>navigate(`${classe_initiale.id}`)}/>}  </td>
                        </tr>
                  )
                    
                }
                )
            
        )
        
            }   */
            function AlertNotification(idclasse_initiale){
                Swal.fire({
                    title:'Etes-vous sûr de vouloir supprimer cette classe ?',
                    text:'Cette classe sera supprimée',
                    icon:'warning',
                    showDenyButton:true,
                    showCancelButton:true,
                    confirmButtonText:'Confirmer',
                    denyButtonText:'Annuler'
                }).then((resultat)=>{
                    if(resultat.isConfirmed){
                        navigate(`delete/${idclasse_initiale}`)
                            }
                })
            }
    return(
        <>
      <div className="container-fluid py-4 px-3">
    {/* En-tête Dynamique */}
    <div className="card border-0 shadow-sm mb-4 bg-white rounded-4">
        <div className="card-body p-4">
            <div className="row align-items-center g-3">
                <div className="col-12 col-lg-5">
                    <h2 className="h4 fw-bold text-dark mb-1">Gestion des Classes</h2>
                    <p className="text-muted small mb-0">Total : <span className="badge bg-primary rounded-pill">{records.length}</span> classes enregistrées</p>
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                    <div className="input-group shadow-sm">
                        <span className="input-group-text bg-white border-end-0"><i className="bi bi-search text-primary"></i></span>
                        <input type="text" className="form-control border-start-0 ps-0" placeholder="Rechercher une classe..." onChange={(e)=>setSearch(e.target.value.toLowerCase())} value={search} />
                    </div>
                </div>
                <div className="col-12 col-md-6 col-lg-3 text-md-end">
                    <button onClick={()=>navigate('insertion')} className="btn btn-success w-100 shadow-sm rounded-3 py-2">
                        <PersonPlus className="me-2" size={20} /> Ajouter une classe
                    </button>
                </div>
            </div>
        </div>
    </div>

    {/* Système d'onglets pour séparer Actives/Désactivées */}
    <ul className="nav nav-pills mb-3 gap-2" id="pills-tab" role="tablist">
        <li className="nav-item" role="presentation">
            <button className="nav-link active rounded-pill px-4 shadow-sm" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#actives" type="button">
                Classes Activées
            </button>
        </li>
        <li className="nav-item" role="presentation">
            <button className="nav-link rounded-pill px-4 shadow-sm btn-outline-danger" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#desactivees" type="button">
                Désactivées ({records.filter(r => r.etat === "Désactivée").length})
            </button>
        </li>
    </ul>

    <div className="tab-content" id="pills-tabContent">
        {/* Panneau Classes Actives */}
        <div className="tab-pane fade show active" id="actives">
            <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
                <div className="table-responsive">
                    <table className="table table-hover align-middle mb-0">
                        <thead className="bg-light text-secondary">
                            <tr>
                                <th className="ps-4">#</th>
                                <th>Classe</th>
                                <th>Niveau</th>
                                <th>Titulaire</th>
                                <th className="text-end pe-4">Actions</th>
                            </tr>
                        </thead>
                        <tbody>{Iteration()}</tbody>
                    </table>
                </div>
            </div>
        </div>

        {/* Panneau Classes Désactivées */}
        <div className="tab-pane fade" id="desactivees">
            <div className="card border-0 shadow-sm rounded-4 overflow-hidden border-start border-danger border-4">
                <div className="table-responsive">
                    <table className="table table-hover align-middle mb-0 text-muted">
                        <tbody>{Desactive()}</tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

    {/* Pagination Modernisée */}
    <footer className="d-flex flex-wrap justify-content-between align-items-center mt-4 px-2">
        <div className="d-flex align-items-center gap-2 mb-3 mb-md-0">
            <span className="small text-muted">Afficher</span>
            <input type="number" className="form-control form-control-sm w-25" value={recordperpage} onChange={(e)=>setRecordperpage(e.target.value)} />
            <span className="small text-muted">par page</span>
        </div>
        
        <nav>
            <ul className="pagination pagination-sm mb-0 shadow-sm">
                <li className="page-item"><button className="page-link px-3" onClick={Prepage}>Précédent</button></li>
                {numbers.map((n, i) => (
                    <li key={i} className={`page-item ${curentpage === n ? 'active' : ''}`}>
                        <button className="page-link" onClick={() => changeCPage(n)}>{n}</button>
                    </li>
                ))}
                <li className="page-item"><button className="page-link px-3" onClick={Nextpage}>Suivant</button></li>
            </ul>
        </nav>
    </footer>
</div>

        </>
    )
function Prepage(){
    if(curentpage > 1){
        setCurentpage(curentpage-1)
    }
}
function changeCPage(id){
   setCurentpage(id)
}
function Nextpage(){
    if(curentpage < npage){
       // alert(curentpage)
        setCurentpage(curentpage+1)
    }
}

}
export default Classe

